import React from "react";
import { useRoutes } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Provider } from "react-redux";
import { Store } from "./redux/Store";
import { AllPages } from "./routes/routes";
import { SettingsProvider } from "contexts/settingsContext";
import AppTheme from "@/components/shared/appTheme/app-theme";
import { MenuActionProvider } from "contexts/MenuContext";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ToastWrapper from "./components/custom/custom-toast";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  const all_pages = useRoutes(AllPages());
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={Store}>
        <SettingsProvider>
          <MenuActionProvider>
            <AppTheme>
              <ToastWrapper />
              {all_pages}
            </AppTheme>
          </MenuActionProvider>
        </SettingsProvider>
      </Provider>
    </QueryClientProvider>
  );
}

export default Sentry.withProfiler(App);
